import React from 'react'
import styles from './SearchBar.module.scss'

export default function SearchBar({ value, onChange, placeholder = 'Поиск…' }) {
  return (
    <div className={styles.wrap}>
      <span className={styles.icon}>🔍</span>
      <input
        className={styles.input}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button className={styles.clear} onClick={() => onChange('')}>×</button>
      )}
    </div>
  )
}
